import { render, staticRenderFns } from "./GroupAdmins.vue?vue&type=template&id=ba3b66e0&scoped=true&"
import script from "./GroupAdmins.vue?vue&type=script&lang=js&"
export * from "./GroupAdmins.vue?vue&type=script&lang=js&"
import style0 from "./GroupAdmins.vue?vue&type=style&index=0&id=ba3b66e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3b66e0",
  null
  
)

export default component.exports